import styled from 'styled-components';

export const WrapperChatTips = styled.div`
  max-width: 493px;
  min-height: 122px;
`;

export const WrapperChatTipsImages = styled.div`
  width: 59px;
  height: 59px;
  border: 4px solid ${({ theme }) => theme.colors.primary.main};
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 96px;
    height: 96px;
  }
`;

export const WrapperChatTipsSubtitle = styled.div`
  border-radius: 20px 0px 20px 20px;
  min-height: 47px;
  width: fit-content;
  margin-left: auto;
  max-width: 367px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
